import { render, staticRenderFns } from "./ArticleInfoGooglePrefered.vue?vue&type=template&id=32ff8405&scoped=true"
import script from "./ArticleInfoGooglePrefered.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoGooglePrefered.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoGooglePrefered.vue?vue&type=style&index=0&id=32ff8405&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff8405",
  null
  
)

export default component.exports